import { render, staticRenderFns } from "./ReportIncomeTable.vue?vue&type=template&id=0fb8e1e1&"
import script from "./ReportIncomeTable.vue?vue&type=script&lang=js&"
export * from "./ReportIncomeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports